<template>
  <span>{{ animatedNumber }}</span>
</template>

<script>
import { TweenLite } from "gsap";

export default {
  name: "CounterComponent",
  props: {
    count: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      number: 0,
      tweenedNumber: 0
    };
  },
  computed: {
    animatedNumber: function() {
      return this.tweenedNumber.toFixed(0);
    }
  },
  watch: {
    number: function(newValue) {
      TweenLite.to(this.$data, 1, { tweenedNumber: newValue });
    },
    count: function(newValue) {
      this.number = this.count;
    },
  },
  mounted () {
    this.number = this.count
  },
};
</script>

